<template>
    <base-dialog :value="dialog" :title="$t('common.note_from_coach')" :width="400" persistent @input="onDialogInput"
        @close="hide">
        <div class="note-message">{{ message }}</div>
        <v-img :src="imgPlaceholder" width="30" class="ml-auto mt-4 img-logo" />
    </base-dialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "NoteMessageDialog",
    components: { BaseDialog },
    data() {
        return {
            dialog: false,
            message: ''
        }
    },
    methods: {
        show(message) {
            const vm = this
            vm.dialog = true
            vm.message = message
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.message = ''
        },
        onDialogInput(val) {
            if (!val) this.hide()
        },
    },
}
</script>

<style scoped>
.note-message {
    text-align: center;
    font-size: var(--fs-body);
    line-height: 1.5;
    color: var(--v-txtPrimary-base);
}

.img-logo {
    opacity: 0.75;
    border-radius: 8px;
}
</style>
